import React from "react";

const Input = ({ type, label, bold, placeholder, preventPaste, value, setValue, disabled, readOnly, onFocus, errors, name, errorMessage, labelStyle = {} }) => {

    return (<div>
        <label style={{ display: 'flex', marginTop: '15px', fontWeight: bold ? '800' : '400', fontSize: '15px', color: '#000', ...labelStyle }}>{label || ''}</label>
        <input onPaste={(e) => { preventPaste && e.preventDefault(); return false }} autoComplete="false" disabled={!!disabled} readOnly={!!readOnly} onFocus={onFocus} className={errors.includes(name) ? 'error' : ''} type={type} placeholder={placeholder || ''} value={value} onChange={(e) => setValue(e.target.value)} />
        {errorMessage && <p style={{ margin: 0, fontSize: '13px', color: 'red' }}>{errorMessage}</p>}
    </div>)

}

export default Input
